module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('xtitle'), _vm._v(" "), _c('div', {
    staticClass: "gridlist-demo-container",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('div', {
    staticClass: "hot"
  }, [_vm._v("热门")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.title), function(n) {
    return _c('mu-col', {
      key: n.singerid,
      staticStyle: {
        "margin": "10px"
      },
      attrs: {
        "width": "20",
        "tablet": "30",
        "desktop": "25"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "border-radius": "50%"
      },
      attrs: {
        "src": n.imgurl,
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.songlist(n.singerid)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "text-align": "center",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(n.singername))])])
  })), _vm._v(" "), (_vm.xianA) ? _c('div', {
    staticClass: "hot A"
  }, [_vm._v("A")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myA), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianB) ? _c('div', {
    staticClass: "hot B"
  }, [_vm._v("B")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myB), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianC) ? _c('div', {
    staticClass: "hot C"
  }, [_vm._v("C")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myC), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianD) ? _c('div', {
    staticClass: "hot D"
  }, [_vm._v("D")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myD), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianE) ? _c('div', {
    staticClass: "hot E"
  }, [_vm._v("E")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myE), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianF) ? _c('div', {
    staticClass: "hot F"
  }, [_vm._v("F")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myF), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianG) ? _c('div', {
    staticClass: "hot G"
  }, [_vm._v("G")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myG), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianH) ? _c('div', {
    staticClass: "hot H"
  }, [_vm._v("H")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myH), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianI) ? _c('div', {
    staticClass: "hot I"
  }, [_vm._v("I")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myI), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianJ) ? _c('div', {
    staticClass: "hot J"
  }, [_vm._v("J")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myJ), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianK) ? _c('div', {
    staticClass: "hot K"
  }, [_vm._v("K")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myK), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianL) ? _c('div', {
    staticClass: "hot L"
  }, [_vm._v("L")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myL), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianM) ? _c('div', {
    staticClass: "hot M"
  }, [_vm._v("M")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myM), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianN) ? _c('div', {
    staticClass: "hot N"
  }, [_vm._v("N")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myN), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianO) ? _c('div', {
    staticClass: "hot O"
  }, [_vm._v("O")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myO), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianP) ? _c('div', {
    staticClass: "hot P"
  }, [_vm._v("P")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myP), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianQ) ? _c('div', {
    staticClass: "hot Q"
  }, [_vm._v("Q")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myQ), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianR) ? _c('div', {
    staticClass: "hot R"
  }, [_vm._v("R")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myR), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianS) ? _c('div', {
    staticClass: "hot S"
  }, [_vm._v("S")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myS), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianT) ? _c('div', {
    staticClass: "hot T"
  }, [_vm._v("T")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myT), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianU) ? _c('div', {
    staticClass: "hot U"
  }, [_vm._v("U")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myU), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianV) ? _c('div', {
    staticClass: "hot V"
  }, [_vm._v("V")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myV), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianW) ? _c('div', {
    staticClass: "hot W"
  }, [_vm._v("W")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myW), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianX) ? _c('div', {
    staticClass: "hot X"
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myX), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianY) ? _c('div', {
    staticClass: "hot Y"
  }, [_vm._v("Y")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myY), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianZ) ? _c('div', {
    staticClass: "hot Z"
  }, [_vm._v("Z")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myZ), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xian) ? _c('div', {
    staticClass: "hot jin"
  }, [_vm._v("#")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.my), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "outbox"
  }, [_c('div', {
    staticClass: "word_sort",
    attrs: {
      "id": "J_word_sort"
    }
  }, [_c('ul', _vm._l((_vm.shouzimu), function(ele, index) {
    return _c('li', {
      class: {
        'gao': _vm.isShow == index
      },
      attrs: {
        "name": index
      },
      on: {
        "click": function($event) {
          _vm.setscroll(ele, index)
        }
      }
    }, [_vm._v(_vm._s(ele))])
  }))])]), _vm._v(" "), _c('xload', {
    attrs: {
      "getload": _vm.load
    }
  }), _vm._v(" "), _c('xlouti')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-650d79c5"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZhenV_RT/xsinglist.vue
// module id = 266
// module chunks = 0